import { render, staticRenderFns } from "./PendencyComment.vue?vue&type=template&id=550e9ba5"
import script from "./PendencyComment.vue?vue&type=script&lang=js"
export * from "./PendencyComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports